/**
 * Ключи файлов карт в порядке backend-колоды — должен совпадать 1-в-1 с TAROT_DECK
 * в packages/modules/src/data/tarotDeck.ts (доку доступен только индекс через numbers.cards,
 * сам ключ на фронт не передаётся). Файлы — apps/webapp/public/assets/tarot/{key}.webp.
 */
export const TAROT78_KEYS: readonly string[] = [
  "major-00-fool",
  "major-01-magician",
  "major-02-high-priestess",
  "major-03-empress",
  "major-04-emperor",
  "major-05-hierophant",
  "major-06-lovers",
  "major-07-chariot",
  "major-08-strength",
  "major-09-hermit",
  "major-10-wheel-of-fortune",
  "major-11-justice",
  "major-12-hanged-man",
  "major-13-death",
  "major-14-temperance",
  "major-15-devil",
  "major-16-tower",
  "major-17-star",
  "major-18-moon",
  "major-19-sun",
  "major-20-judgement",
  "major-21-world",
  "wands-ace",
  "wands-02",
  "wands-03",
  "wands-04",
  "wands-05",
  "wands-06",
  "wands-07",
  "wands-08",
  "wands-09",
  "wands-10",
  "wands-page",
  "wands-knight",
  "wands-queen",
  "wands-king",
  "cups-ace",
  "cups-02",
  "cups-03",
  "cups-04",
  "cups-05",
  "cups-06",
  "cups-07",
  "cups-08",
  "cups-09",
  "cups-10",
  "cups-page",
  "cups-knight",
  "cups-queen",
  "cups-king",
  "swords-ace",
  "swords-02",
  "swords-03",
  "swords-04",
  "swords-05",
  "swords-06",
  "swords-07",
  "swords-08",
  "swords-09",
  "swords-10",
  "swords-page",
  "swords-knight",
  "swords-queen",
  "swords-king",
  "pentacles-ace",
  "pentacles-02",
  "pentacles-03",
  "pentacles-04",
  "pentacles-05",
  "pentacles-06",
  "pentacles-07",
  "pentacles-08",
  "pentacles-09",
  "pentacles-10",
  "pentacles-page",
  "pentacles-knight",
  "pentacles-queen",
  "pentacles-king",
];
